<template>
  <v-col cols="12">
    <div>
      <div class="text-h6">{{ nombreCompleto }}</div>
      <div class="text-subtitle-1">CUIP: {{ candidato.cuip || 'Sin CUIP' }}</div>
    </div>
    <v-form ref="form" v-model="formValido" class="col-12 mt-2">
      <v-select
        v-model="form.fk_idEstatus"
        background-color="transparent"
        color="secondary"
        rounded
        filled
        dense
        :items="estatusCursoPersonal"
        item-value="id"
        item-text="title"
        :rules="[(v) => !!v || 'El estatus es obligatorio']"
      >
        <template v-slot:label>Estatus <span class="red--text">*</span></template>
      </v-select>
      <BaseInput v-model="form.calificacion" label="Calificación" />
      <BaseInput v-model="form.calificacionEvaluacion" label="Calificación de evaluador" />
      <BaseTextArea filled v-model="form.comentario" label="Comentario" />
      <v-switch color="secondary" v-model="form.asistencia" label="Asistió a la capacitación" inset />
    </v-form>
    <div class="col-12 text-center">
      <TextButton
        color="secondary"
        class="primary--text mb-3"
        :loading="loading"
        :disabled="loading || !formValido"
        @click="guardarCambios"
      >
        Guardar calificación
      </TextButton>
    </div>
  </v-col>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseInput from './base/BaseInput.vue'
import BaseTextArea from './base/BaseTextArea.vue'
import TextButton from './base/TextButton.vue'

export default {
  components: {
    BaseInput,
    BaseTextArea,
    TextButton,
  },
  props: {
    candidato: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      formValido: false,
      form: {
        fk_idEstatus: this.candidato.fk_idEstatus,
        asistencia: this.candidato.asistencia,
        calificacion: this.candidato.calificacion,
        calificacionEvaluacion: this.candidato.calificacionEvaluacion,
        comentario: this.candidato.comentario,
      },
    }
  },
  computed: {
    ...mapGetters('estatusCursoPersonal', { estatusCursoPersonal: 'getEstatusCursoPersonal' }),

    nombreCompleto() {
      return this.candidato.nombrePersonal || ''
    },
  },
  methods: {
    ...mapMutations('dialog', ['CLOSE_DIALOG']),
    ...mapActions('capacitaciones', ['actualizarCursoNoProgramadoPersonal']),

    async guardarCambios() {
      if (!this.$refs.form.validate()) return

      this.loading = true
      try {
        await this.actualizarCursoNoProgramadoPersonal({
          idCursoPersonal: this.candidato.id,
          payload: {
            fk_idCurso: this.candidato.fk_idCurso,
            fk_idPersonal: this.candidato.fk_idPersonal,
            ...this.form,
          },
        })
        this.$emit('updated')
        this.CLOSE_DIALOG()
      } catch {
        // El store ya muestra el mensaje de error en el snackbar.
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
